var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.52,
    height: 20,
    viewBox: "0 0 18.52 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12606",
    "data-name": "Group 12606",
    transform: "translate(-44.795 -189.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M16.694,6.57a4.923,4.923,0,0,1,3.507,1.4,4.593,4.593,0,0,1,1.365,3.268A4.9,4.9,0,0,1,20.279,14.9a15.141,15.141,0,0,1,2.591,1.164,7.682,7.682,0,0,1,3.018,2.963l.066.124v7.42H7.434V19.15l.066-.124c1.21-2.268,3.662-3.455,5.708-4.16a5.919,5.919,0,0,1-1.385-3.63,4.6,4.6,0,0,1,1.364-3.27A4.922,4.922,0,0,1,16.694,6.57Zm8.14,12.864c-1.231-2.164-3.938-3.2-5.883-3.789l-.134-1.011a3.5,3.5,0,0,0,1.628-3.4A3.479,3.479,0,0,0,19.411,8.76a3.985,3.985,0,0,0-5.435,0,3.482,3.482,0,0,0-1.034,2.477,4.57,4.57,0,0,0,1.364,3.128.96.96,0,0,1,.258.266l.007,0v.006a.749.749,0,0,1,.054.113.421.421,0,0,0-.056-.1l-.132.99c-3.982,1.209-5.28,2.716-5.883,3.787V25.45h16.28Z",
    transform: "translate(37.361 183.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M13.536,9.6c.619.056.639-.409,2.333-.309,2.531.149,1.713.914,3.439.964,1.346-.051,1.288-.478,1.908-.655a7.887,7.887,0,0,0-3.84-2.4,8.547,8.547,0,0,0-3.84,2.4Z",
    transform: "translate(36.683 183.115)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M12.8,27.52h-1.12V23.04H12.8Z",
    transform: "translate(36.889 181.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M23.854,27.52h-1.12V23.04h1.12Z",
    transform: "translate(35.661 181.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M17.3,20.927a5.624,5.624,0,0,1-3.98-1.431,2.277,2.277,0,0,1-.385-1.976,7.85,7.85,0,0,1,.246-1.145l1.07.33-.535-.165.535.165a6.8,6.8,0,0,0-.208.976c-.109.834.067,1.021.069,1.023a4.577,4.577,0,0,0,3.188,1.1,4.577,4.577,0,0,0,3.188-1.1s.18-.191.067-1.036a6.725,6.725,0,0,0-.206-.963l1.07-.33a7.848,7.848,0,0,1,.246,1.145,2.277,2.277,0,0,1-.385,1.976A5.624,5.624,0,0,1,17.3,20.927Z",
    transform: "translate(36.755 182.096)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e581a5bf58aa882f91779b34e28d99f4.svg";
export { ForwardRef as ReactComponent };